export function createOutgoingTone(onBlocked = () => {}) {
  const audio = new Audio(
    "/assets/sounds/mixkit_melodical_flute_music_notification_2310.wav",
  );
  audio.loop = true;
  let enabled = false;
  const sync = () => {
    if (enabled && document.visibilityState === "visible")
      audio
        .play()
        .then(() => onBlocked(false))
        .catch(() => onBlocked(true));
    else audio.pause();
  };
  document.addEventListener("visibilitychange", sync);
  return {
    resume() {
      if (enabled)
        return audio
          .play()
          .then(() => onBlocked(false))
          .catch(() => onBlocked(true));
    },
    start() {
      enabled = true;
      sync();
    },
    stop() {
      onBlocked(false);
      enabled = false;
      audio.pause();
      audio.currentTime = 0;
    },
    dispose() {
      enabled = false;
      audio.pause();
      audio.src = "";
      document.removeEventListener("visibilitychange", sync);
    },
  };
}
